import { ReactElement } from 'react'
import {
  Box,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from '@mui/material'
import { meterToMillimeter } from '@utils'
import { remapMaterialIdentifier } from 'src/components/pages/Editor/components/SingleElementCSForm/components/FormFields'
import { cltLayerOrientationLabels } from './constants'

interface Props {
  layers: CLTLayer[]
}

const CLTLayerList = ({ layers }: Props): ReactElement | null => {
  if (!layers.length) return null

  return (
    <Box>
      <Typography variant="subtitle2" mb={1}>
        Lagen
      </Typography>
      <TableContainer>
        <Table size="small" aria-label="CLT Lagen">
          <TableHead>
            <TableRow>
              <TableCell>Dicke [mm]</TableCell>
              <TableCell>Orientierung</TableCell>
              <TableCell>Material</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {layers.map((plyLayer, index) => (
              <TableRow key={index} data-cy={`clt-ply-layer-${index}`}>
                <TableCell>{meterToMillimeter(plyLayer.thickness)}</TableCell>
                <TableCell>{cltLayerOrientationLabels[plyLayer.orientation]}</TableCell>
                <TableCell>{remapMaterialIdentifier(plyLayer.material.identifier ?? '')}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
}

export default CLTLayerList
